var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigCheck"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39",
    x: 1,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#E5F4F9",
    stroke: "#9ADFF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    filter: "url(#filter0_d_1098_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2109 7.30469C20.6172 7.67969 20.6172 8.33594 20.2109 8.71094L12.2109 16.7109C11.8359 17.1172 11.1797 17.1172 10.8047 16.7109L6.80469 12.7109C6.39844 12.3359 6.39844 11.6797 6.80469 11.3047C7.17969 10.8984 7.83594 10.8984 8.21094 11.3047L11.5234 14.5859L18.8047 7.30469C19.1797 6.89844 19.8359 6.89844 20.2109 7.30469Z",
    fill: "#428916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2109 7.30469C20.6172 7.67969 20.6172 8.33594 20.2109 8.71094L12.2109 16.7109C11.8359 17.1172 11.1797 17.1172 10.8047 16.7109L6.80469 12.7109C6.39844 12.3359 6.39844 11.6797 6.80469 11.3047C7.17969 10.8984 7.83594 10.8984 8.21094 11.3047L11.5234 14.5859L18.8047 7.30469C19.1797 6.89844 19.8359 6.89844 20.2109 7.30469Z",
    stroke: "#428916"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1098_1531",
    x: 3,
    y: 5.5,
    width: 21.0156,
    height: 17.0156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1098_1531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1098_1531",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.0e7ca42aa2c89735ff87261315528fd5.svg";
export { ForwardRef as ReactComponent };